import React, { useState, useRef } from 'react';

export default ({
    item: { id, name, defaultValue },
    dateMinMax = 100,
    placeholder = null,
    onBlur = null,
    customClass = '',
}) => {
    const swapId = `${id}Swap`;
    const dateInput = useRef();
    const [myState, setState] = useState({ hasValue: false, value: null });
    const changeHandler = event => onBlur(event);
    const change = e => {
        if (e.target.id === swapId) {
            setState({ hasValue: true, value: e.target.value });
            setTimeout(() => {
                dateInput.current.focus();
            }, 100);
            return;
        }
        if (e.target.value) {
            setState({ hasValue: true, value: e.target.value });
        } else setState({ hasValue: false, value: null });

        changeHandler(e);
    };
    const getMaxDate = () => {
        let date = new Date();
        date.setFullYear(date.getFullYear() + dateMinMax);
        return date.toISOString().slice(0, 10);
    };
    const getMinDate = () => {
        let date = new Date();
        date.setFullYear(date.getFullYear() - dateMinMax);
        return date.toISOString().slice(0, 10);
    };

    return (
        <>
            <input
                id={swapId}
                name={swapId}
                className={`woo-date ${
                    myState.hasValue ? 'hidden' : ''
                } ${customClass}`.trim()}
                onFocus={e => change(e)}
                type={'text'}
                placeholder={placeholder}
                defaultValue={defaultValue}
            ></input>

            <input
                ref={dateInput}
                id={id}
                className={`woo-date ${
                    myState.hasValue ? '' : 'hidden'
                } ${customClass}`.trim()}
                name={name}
                onBlur={e => {
                    change(e);
                }}
                type="date"
                placeholder={placeholder}
                defaultValue={defaultValue}
                max={dateMinMax && getMaxDate()}
                min={dateMinMax && getMinDate()}
            ></input>
        </>
    );
};
